var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductM1EcuTable',{attrs:{"m1PiEcus":_vm.m1EcuAttributes && _vm.m1EcuAttributes.length ? _vm.m1EcuAttributes : null,"tableClass":"table-mobile"}})}
var staticRenderFns = []

export { render, staticRenderFns }